import { Grid, useTheme, Stack, GridBreak, RichTextReader, Typography, Box, Card } from "@compass/core";
import { SubmitButton } from "components";
import { Form } from "generated/openApi";
import { useEffect } from "react";

type publicSurveyTitleProps = {
  survey: Form;
  showSubmissionMessage: boolean | undefined;
  // beginSurvey: () => void;
};

export const PublicSurveyTitle = ({ survey, showSubmissionMessage }: publicSurveyTitleProps) => {
  const theme = useTheme();

  useEffect(() => {}, []);

  return (
    <Card sx={{ maxWidth: "1100px", width: "100%" }}>
      <Stack px={3} py={7} spacing="lg" width="100%">
        <Grid container spacing="sm">
          <Grid item xs={12}>
            <RichTextReader html={survey.title} />
          </Grid>

          <Grid item xs={12}>
            <RichTextReader html={survey.subTitle} />
          </Grid>

          <Grid item xs={12}>
            {!showSubmissionMessage && (<RichTextReader html={survey.instruction} />)}
          </Grid>

          <GridBreak />

          {/* <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
            <Box sx={{ paddingTop: 5 }}>
              <SubmitButton label="Begin Survey" onClick={() => beginSurvey()} />
            </Box>
          </Grid> */}
        </Grid>
      </Stack>
    </Card>
  );
};
